import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';

import { styledComponentsTheme } from '@frontend/components/src/styledComponentsTheme';

const rotation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const Inner = styled.span`
  display: inline-block;
  width: 1em;
  height: 1em;
  line-height: 1em;
  border: 0.15em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: ${rotation} 1s infinite linear;
`;

const Wrapper = styled.span`
  /* NOTE: position absolute, top & left 0, and full width and height..
  ...mean this fills any container and doesn't require a container for use. */
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: wait;

  ${(props) =>
    props.size &&
    `
    font-size: ${props.size}px;
  `}

  ${(props) =>
    props.color &&
    `
    color: ${props.color};
  `};
`;

// NOTE: this brings in the component theme for use in styling without use of a ThemeProvider.
Wrapper.defaultProps = {
  theme: styledComponentsTheme,
};

/**
 * @deprecated use Spinner from '@frontend/components' instead.
 */
export const OldSpinner = ({ color, size, ...props }) => (
  <Wrapper color={color} size={size} {...props}>
    <Inner />
  </Wrapper>
);

OldSpinner.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};
